import React, { useState, useEffect } from 'react'
import {
  Col,
  Panel,
  Row,
  Modal,
  Button,
  Icon,
  Message,
  Table,
  ControlLabel,
  Input,
  ButtonToolbar,
  Uploader,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isImageOrPdfOrMsFile,
  isValidators,
  requiredFiled,
} from '../../../utils/ValidatorUtils'
import notification from '../../../utils/notification'
import { isEmpty } from 'lodash-es'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import {
  deleteDocumentManageIaFile,
  deleteIaFileMin,
  downloadDocumentManageIaFile,
  getEmailAttchMange,
  saveDocumentManageIa,
  saveEmailAttchMange,
  saveLinkEmailAttchMange,
  searchDocumentManageIa,
} from '../../../redux/actions/IaDucumentManagement'
import {
  DEFAULT_ERR_MSG,
  DELETE_FILE_FAILED_MSG,
  DELETE_FILE_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
} from '../../../constants/msgText'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import TooltipButton from '../../../components/buttons/TooltipButton'
import InputForm from '../../../components/forms/input/InputForm'

export default function LinkedAttManagementWidget({ schema: _schema, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  // const [dataTable, setDataTable] = useState()
  // const [dataTableLinked, setDataTableLined] = useState()
  const [isAddData, setIsAddData] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [rowId, setRowId] = useState()
  const [delFile, setDelFile] = useState()
  const [requestBody, setRequestBody] = useState()
  // const [schema, setschema] = useState(schemaLinked)
  const [schema, setSchema] = useState(_schema)

  const twoCol = {
    first: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    full: {
      _lg: 24,
      _md: 24,
      _sm: 24,
      _xs: 24,
    },
  }

  // useEffect(() => {
  //   console.log('scheeeee => ', schema)
  //   setSchema(_schema)
  // }, [])

  const onClearSearchFiles = async () => {
    // onClearSearch()
    await callApiSearchFiles()
  }

  const onClear = () => {
    setValue(schema?.linkedInContentIAp05QrCode?.name, '')
    setValue(schema?.linkedInContentIAp05?.name, '')

    setValue(schema?.linkedInContentIAp06QrCode?.name, '')
    setValue(schema?.linkedInContentIAp06?.name, '')
  }

  const callApiSearchFiles = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getEmailAttchMange()
      console.log('callApiSearchFiles ', response)
      if (response) {
        setSchema(response.linkedInContentForm)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleAddForm = () => {
    setIsAddData(true)
    onClearSearchFiles()
  }

  const onSubmit = async (data) => {
    console.log('onSubmit => ', data)
    // console.log('requestttt => ', requestBody)

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()

      formData.append('FilesIAp05Id', schema?.linkedInContentIAp05QrCode?.id || '')
      data.attachFilesIAp05QrCode &&
        data.attachFilesIAp05QrCode?.forEach((element) => {
          formData.append('FilesIAp05QrCode', element.blobFile)
        })
      formData.append('linkedInContentIAp05', data.linkedInContentIAp05 || '')
      formData.append('FilesIAp05QrCodeStr', schema?.linkedInContentIAp05QrCode?.path || '')

      formData.append('FilesIAp06Id', schema?.linkedInContentIAp06QrCode?.id || '')
      data.attachFilesIAp06QrCode &&
        data.attachFilesIAp06QrCode?.forEach((element) => {
          formData.append('FilesIAp06QrCode', element.blobFile)
        })
      formData.append('linkedInContentIAp06', data.linkedInContentIAp06 || '')
      formData.append('FilesIAp06QrCodeStr', schema?.linkedInContentIAp06QrCode?.path || '')

      const response = await saveLinkEmailAttchMange(formData)
      console.log('ressss ooo => ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setSchema(response.linkedInContentForm)
        onClear()
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onFileHandle = async (rowData, type) => {
    console.log('rowdtat => ', rowData)
    console.log('teype => ', type)

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDocumentManageIaFile(rowData.path)

      if (type == 'download') {
        downloadFile(file, rowData?.label || rowData?.name)
      } else {
        previewFile(file, rowData?.label)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const delFiles = async () => {
    console.log('requestBody => ', requestBody)

    // return false
    setIsLoading(true)
    startLoading()
    try {
      // { id: rowId }
      const response = await deleteIaFileMin(requestBody)
      // console.log('ressss ooo => ', response)
      if (response.success) {
        notification.open('success', {
          title: DELETE_FILE_SUCCESS_MSG,
          duration: 5000,
        })
        callApiSearchFiles()
        setIsShowConfirmDelete(false)
      } else {
        notification.open('error', {
          title: DELETE_FILE_FAILED_MSG,
          duration: 5000,
        })
        setIsShowConfirmDelete(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log('error', e)
        if (e?.response?.data) {
          notification.open('error', {
            title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
            duration: 5000,
          })
        } else {
          setError({})
        }
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        collapsible
        defaultExpanded
        header={schema.header}
        bordered
        style={{ marginTop: 20 }}
      >
        <div style={{ paddingLeft: 40, paddingRight: 40 }}>
          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <InputForm
                schema={schema.linkedInContentIAp06}
                // rows={3}
                // componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              {console.log('schema => ', schema)}
              <ControlLabel>
                {requiredFiled(
                  schema.linkedInContentIAp06QrCode.validators,
                  schema.linkedInContentIAp06QrCode.label
                )}
              </ControlLabel>

              {schema.linkedInContentIAp06QrCode.type && (
                <Message
                  style={{ marginTop: 10, marginBottom: 10 }}
                  showIcon
                  type="info"
                  description={`ชนิดที่รองรับ ${
                    schema.linkedInContentIAp06QrCode.type || '.jpg, .jpeg, .png'
                  } และขนาดไฟล์ไม่เกิน ${schema.linkedInContentIAp06QrCode.size || 50} MB`}
                />
              )}

              <Controller
                name={schema.linkedInContentIAp06QrCode.name}
                control={control}
                defaultValue={undefined}
                rules={isValidators(schema.linkedInContentIAp06QrCode.validators)}
                render={(props) => {
                  return (
                    <Uploader
                      accept={schema.linkedInContentIAp06QrCode.type || '.docx, .xlsx, .pdf'}
                      draggable
                      autoUpload={false}
                      multiple={false}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          let file = fileList[fileList.length - 1]

                          if (
                            file.blobFile.size >
                            (schema.linkedInContentIAp06QrCode.type || defaultMaxFileSize) *
                              1024 *
                              1024
                          ) {
                            notification.open('error', {
                              title: `ขนาดไฟล์เกิน ${
                                schema.linkedInContentIAp06QrCode.size || defaultMaxFileSize
                              } MB`,
                              duration: 5000,
                            })
                            return
                          }

                          if (isImageOrPdfOrMsFile(file.blobFile.type)) {
                            let files = []
                            files.push(fileList[fileList.length - 1])
                            props.onChange(files)

                            // props.onChange(fileList)
                            //setFileTypeError(false)
                          } else {
                            //setFileTypeError(true)
                            notification.open('error', {
                              title:
                                'ชนิดที่รองรับ ' + schema.linkedInContentIAp06QrCode.type ||
                                '.docx, .xlsx, .pdf',
                              duration: 5000,
                            })
                          }
                        }
                      }}
                    >
                      <div style={{ lineHeight: '100px' }}>
                        <Icon size="4x" icon="upload2" />
                        <small
                          style={{
                            marginTop: '-70px',
                            display: 'block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                        </small>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
            >
              <table border={1} width={'100%'}>
                <tr>
                  <th style={{ width: '10%' }}>
                    <p style={{ padding: 3 }}>ลำดับ</p>
                  </th>
                  <th>
                    <p style={{ padding: 3 }}>ไฟล์</p>
                  </th>
                  <th style={{ width: '20%' }}>
                    <p style={{ padding: 3 }}></p>
                  </th>
                </tr>
                {!schema.linkedInContentIAp06QrCode.path ? (
                  <>
                    <tr>
                      <td style={{ textAlign: 'center' }} colspan="3">
                        <p style={{ padding: 3 }}>...ไม่พบข้อมูล...</p>
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr>
                      <td width={'10%'} style={{ textAlign: 'center' }}>
                        <p style={{ padding: 3 }}>1.</p>
                      </td>
                      <td>
                        <p style={{ padding: 3 }}>{schema.linkedInContentIAp06QrCode.label}</p>
                      </td>
                      <td width={'20%'} style={{ textAlign: 'center' }}>
                        <div style={{ padding: 3 }}>
                          <ButtonGroup>
                            <TooltipButton
                              isStart={true}
                              icon="eye"
                              tooltip={`แสดง`}
                              disabled={!schema.linkedInContentIAp06QrCode.path}
                              onClick={(e) =>
                                onFileHandle(schema.linkedInContentIAp06QrCode, 'preview')
                              }
                            />
                            <TooltipButton
                              isStart={false}
                              icon="download2"
                              tooltip={`ดาวน์โหลด`}
                              disabled={!schema.linkedInContentIAp06QrCode.path}
                              onClick={(e) =>
                                onFileHandle(schema.linkedInContentIAp06QrCode, 'download')
                              }
                            />
                            <TooltipButton
                              isStart={false}
                              icon="trash-o"
                              tooltip={`ลบ`}
                              disabled={!schema.linkedInContentIAp06QrCode.path}
                              iconStyle={{
                                backgroundColor: '#fb8a81',
                                borderRadius: '0px 4px 4px 0px',
                                borderColor: 'fb8a81',
                              }}
                              onClick={() => {
                                // setRowId(schema.linkedInContentIAp06QrCode.id)
                                // setDelFile(schema.linkedInContentIAp06QrCode.path)
                                setRequestBody({
                                  id: schema?.linkedInContentIAp06QrCode?.id || '',
                                  filePath: schema.linkedInContentIAp06QrCode.path || '',
                                })
                                setIsShowConfirmDelete(true)
                              }}
                            />
                          </ButtonGroup>
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </table>
            </Col>
          </Row>
        </div>

        <hr />

        <div style={{ paddingLeft: 40, paddingRight: 40 }}>
          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <InputForm
                schema={schema.linkedInContentIAp05}
                // rows={3}
                // componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ControlLabel>
                {requiredFiled(
                  schema.linkedInContentIAp05QrCode.validators,
                  schema.linkedInContentIAp05QrCode.label
                )}
              </ControlLabel>

              {schema.linkedInContentIAp05QrCode.type && (
                <Message
                  style={{ marginTop: 10, marginBottom: 10 }}
                  showIcon
                  type="info"
                  description={`ชนิดที่รองรับ ${
                    schema.linkedInContentIAp05QrCode.type || '.jpg, .jpeg, .png'
                  } และขนาดไฟล์ไม่เกิน ${schema.linkedInContentIAp05QrCode.size || 50} MB`}
                />
              )}

              <Controller
                name={schema.linkedInContentIAp05QrCode.name}
                control={control}
                defaultValue={undefined}
                rules={isValidators(schema.linkedInContentIAp05QrCode.validators)}
                render={(props) => {
                  return (
                    <Uploader
                      accept={schema.linkedInContentIAp05QrCode.type || '.docx, .xlsx, .pdf'}
                      draggable
                      autoUpload={false}
                      multiple={false}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          let file = fileList[fileList.length - 1]

                          if (
                            file.blobFile.size >
                            (schema.linkedInContentIAp05QrCode.type || defaultMaxFileSize) *
                              1024 *
                              1024
                          ) {
                            notification.open('error', {
                              title: `ขนาดไฟล์เกิน ${
                                schema.linkedInContentIAp05QrCode.size || defaultMaxFileSize
                              } MB`,
                              duration: 5000,
                            })
                            return
                          }

                          if (isImageOrPdfOrMsFile(file.blobFile.type)) {
                            let files = []
                            files.push(fileList[fileList.length - 1])
                            props.onChange(files)

                            // props.onChange(fileList)
                            //setFileTypeError(false)
                          } else {
                            //setFileTypeError(true)
                            notification.open('error', {
                              title:
                                'ชนิดที่รองรับ ' + schema.linkedInContentIAp05QrCode.type ||
                                '.docx, .xlsx, .pdf',
                              duration: 5000,
                            })
                          }
                        }
                      }}
                    >
                      <div style={{ lineHeight: '100px' }}>
                        <Icon size="4x" icon="upload2" />
                        <small
                          style={{
                            marginTop: '-70px',
                            display: 'block',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                        </small>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
            >
              <table border={1} width={'100%'}>
                <tr>
                  <th style={{ width: '10%' }}>
                    <p style={{ padding: 3 }}>ลำดับ</p>
                  </th>
                  <th>
                    <p style={{ padding: 3 }}>ไฟล์</p>
                  </th>
                  <th style={{ width: '20%' }}>
                    <p style={{ padding: 3 }}></p>
                  </th>
                </tr>
                {!schema.linkedInContentIAp05QrCode.path ? (
                  <>
                    <tr>
                      <td style={{ textAlign: 'center' }} colspan="3">
                        <p style={{ padding: 3 }}>...ไม่พบข้อมูล...</p>
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr>
                      <td width={'10%'} style={{ textAlign: 'center' }}>
                        <p style={{ padding: 3 }}>1.</p>
                      </td>
                      <td>
                        <p style={{ padding: 3 }}>{schema.linkedInContentIAp05QrCode.label}</p>
                      </td>
                      <td width={'20%'} style={{ textAlign: 'center' }}>
                        <div style={{ padding: 3 }}>
                          <ButtonGroup>
                            <TooltipButton
                              isStart={true}
                              icon="eye"
                              tooltip={`แสดง`}
                              disabled={!schema.linkedInContentIAp05QrCode.path}
                              onClick={(e) =>
                                onFileHandle(schema.linkedInContentIAp05QrCode, 'preview')
                              }
                            />
                            <TooltipButton
                              isStart={false}
                              icon="download2"
                              tooltip={`ดาวน์โหลด`}
                              disabled={!schema.linkedInContentIAp05QrCode.path}
                              onClick={(e) =>
                                onFileHandle(schema.linkedInContentIAp05QrCode, 'download')
                              }
                            />
                            <TooltipButton
                              isStart={false}
                              icon="trash-o"
                              tooltip={`ลบ`}
                              disabled={!schema.linkedInContentIAp05QrCode.path}
                              iconStyle={{
                                backgroundColor: '#fb8a81',
                                borderRadius: '0px 4px 4px 0px',
                                borderColor: 'fb8a81',
                              }}
                              onClick={() => {
                                // delFiles(rowData.id)
                                // setRowId(schema.linkedInContentIAp05QrCode.id)
                                // setDelFile(schema.linkedInContentIAp06QrCode.path)
                                setRequestBody({
                                  id: schema?.linkedInContentIAp05QrCode?.id || '',
                                  filePath: schema.linkedInContentIAp05QrCode.path || '',
                                })
                                setIsShowConfirmDelete(true)
                              }}
                            />
                          </ButtonGroup>
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </table>
            </Col>
          </Row>
        </div>

        <div style={{ paddingLeft: 40, paddingRight: 25, marginTop: 20 }}>
          <Row>
            <Col
              lg={twoCol.full._lg}
              md={twoCol.full._md}
              sm={twoCol.full._sm}
              xs={twoCol.full._xs}
              style={{ textAlign: 'right' }}
            >
              <ButtonToolbar style={{ marginRight: 20 }}>
                <SaveButton
                  style={{ minWidth: 120 }}
                  onClick={handleSubmit(onSubmit)}
                  disabled={isLoading}
                >
                  บันทึก
                </SaveButton>
                {/* <CancelButton
                  style={{ minWidth: 120 }}
                  disabled={isLoading}
                  onClick={() => {
                    setIsAddData(false)
                    setRequestBody()
                  }}
                >
                  ยกเลิก
                </CancelButton> */}
              </ButtonToolbar>
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={delFiles}
      />
    </>
  )
}
